import * as Types from "../types/CustomerTypes";

const initialState = {
  list: [],
};

const customerReducer = (state = initialState, action) => {
  switch (action.type) {
    case Types.GET_CUSTOMERS_SUCCESS: {
      const list = action?.result || [];
      return {
        ...state,
        list,
      };
    }
    case Types.CREATE_CUSTOMER_SUCCESS: {
      const list = [action?.result, ...state?.list];
      return {
        ...state,
        list,
      };
    }
    case Types.UPDATE_CUSTOMER_SUCCESS: {
      const list = state?.list?.map((item) => {
        if (item?.id === action?.result?.id) {
          return action?.result;
        }
        return item;
      });
      return {
        ...state,
        list,
      };
    }
    case Types.DELETE_CUSTOMER_SUCCESS: {
      const list = state?.list?.filter(
        (item) => item?.id !== action?.result?.id
      );
      return { ...state, list };
    }
    default:
      return state;
  }
};
export default customerReducer;
